import React from 'react'

function Network() {
  return (
    <div className="rounded-2 bg-white w-full p-4">
    <div className="d-flex gap-3">
      <p className="text-secondary">Carrier</p>
      <p className="text-primary-cre">Network</p>
    </div>
    <div className="container-cre rounded-2 d-flex flex-column gap-4">
      <div>
        <p className="fw-medium text-secondary">Home Network</p>
        <div className="d-flex gap-5">
          <div className="w-75">
            <p className="text-secondary "> Carrier</p>
            <input className="input-cre"></input>
          </div>
          <div className="w-75">
            <p className="text-secondary "> Network</p>
            <input className="input-cre"></input>
          </div>
        </div>
      </div>
      <div>
        <p className="fw-medium text-secondary">Additional Network(s)</p>
        <div className="d-flex gap-5">
          <div className="w-75">
            <p className="text-secondary"> Carrier</p>
            <input className="input-cre"></input>
          </div>
          <div className="w-75">
            <p className="text-secondary"> Network</p>
            <input className="input-cre"></input>
          </div>
        </div>
      </div>
      <div>
        <p className="fw-medium text-secondary">Additional Network(s)</p>
        <div className="d-flex gap-5">
          <div className="w-75">
            <p className="text-secondary "> Carrier</p>
            <input className="input-cre"></input>
          </div>
          <div className="w-75">
            <p className="text-secondary "> Network</p>
            <input className="input-cre"></input>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default Network